import ProjectIndex from './Index'
import ProjectForm from './Form'
import ProjectView from './View'

export default [
  {
    path: '/project',
    name: 'project',
    component: ProjectIndex,
    meta: {
      auth: true,
      bodyClass: 'navbar-top',
      breadcrumb: 'Projects'
    }
  },
  {
    path: '/project/details/:oid',
    name: 'project.details',
    props: true,
    component: ProjectView,
    meta: {
      breadcrumb: 'Project Details'
    }
  },
  {
    path: '/project/add',
    name: 'project.create',
    props: true,
    component: ProjectForm,
    meta: {
      breadcrumb: 'New project'
    }
  }
]
